/**
 * @description: CustomCrearUsuario
 * @author: Santiago Hernández N,
 * @version: jdesk_1.01.0009.4
 **/
import FormJaivana from 'dashboard_jaivana_v1';
class CustomCrearUsuario extends FormJaivana.form {


    constructor(props) {
        

        super(props);
        // Variables de tablas:
        this.gridOptionsSucursales                 =  Object.assign({},this.gridOptions);
        this.configCell                            =  new Map();
       
        // Variables Globales:
        //this.arrayObjetos                        =   new Map();
        //this.arrayCampos                         =   new Map();
        //this.bHayErrores                         =   false;
        //this.bHayError                           =   false;
        //this.datosAgregar                        =   {datos:{}};

        // Funciones:
        this.initForm                               = this.initForm.bind(this);

        //TAB1
        this.deshabilitarCampos                     = this.deshabilitarCampos.bind(this);
        this.validarContinuarTab1                   = this.validarContinuarTab1.bind(this);
        this.sucessValidarUsuario                   = this.sucessValidarUsuario.bind(this);
        this.LimpiarTab1                            = this.LimpiarTab1.bind(this);

        //TAB2
        this.initFormT2                             = this.initFormT2.bind(this);
        this.traerSucursalesActivas                 = this.traerSucursalesActivas.bind(this);
        this.sucessTraerSucursales                  = this.sucessTraerSucursales.bind(this);
        this.setButtonsTable                        = this.setButtonsTable.bind(this);
        this.crearBotonTabla                        = this.crearBotonTabla.bind(this);
        this.accionProcesar                         = this.accionProcesar.bind(this);
        this.actualizarCampoSucursales              = this.actualizarCampoSucursales.bind(this);
        this.validarContinuarTab2                   = this.validarContinuarTab2.bind(this);
        this.LimpiarTab2                            = this.LimpiarTab2.bind(this);

        //TAB3
        this.initFormT3                             = this.initFormT3.bind(this);
        this.traerVendedores                        = this.traerVendedores.bind(this);
        this.validarContinuarTab3                   = this.validarContinuarTab3.bind(this);
        this.LimpiarTab3                            = this.LimpiarTab3.bind(this);

        //TAB4
        this.initFormT4                             = this.initFormT4.bind(this);     
        this.validarContinuarTab4                   = this.validarContinuarTab4.bind(this);
        this.LimpiarTab4                            = this.LimpiarTab4.bind(this);


        //TAB5
        this.initFormT5                             = this.initFormT5.bind(this);
        this.validarContinuarTab5                   = this.validarContinuarTab5.bind(this);
        this.LimpiarTab5                            = this.LimpiarTab5.bind(this);
        this.sucessValidarCrearUsuario              = this.sucessValidarCrearUsuario.bind(this);
        this.sucessCrearUsuario                     = this.sucessCrearUsuario.bind(this);
        this.limpiartodo                            = this.limpiartodo.bind(this);
    }

    initForm() {

        console.log('Formulario CustomCrearUsuario,  @version: jdesk_1.01.0009.4, @author: Santiago Hernández N.');
        //TAB1
        this.deshabilitarCampos();
        this.getField('continuar_basicos').setClick(this.validarContinuarTab1);
        this.getField('cancelar_basicos').setClick(this.LimpiarTab1);    
        
        //TAB2
        this.getField('nombre_sucursal').setOnChange(this.traerSucursalesActivas);
        this.sucursalesSeleccionadas = new Set();
        this.getField('continuar_sucursales').setClick(this.validarContinuarTab2);
        this.getField('cancelar_sucursales').setClick(this.LimpiarTab2); 
        
        //TAB3
        this.getField("codigo_vendedor").setDisabled(true);
        this.getField("nombre_vendedor").setDisabled(true);
        this.getField('estadosino_vendedor').setOnChange(this.traerVendedores);
        this.getField("codigo_facturacion").setDisabled(true);
        this.getField("detalle_facturacion").setDisabled(true);
        this.getField("bodega_principal").setDisabled(true);
        this.getField("nombre_bodega_principal").setDisabled(true);
        this.getField('continuar_ventas').setClick(this.validarContinuarTab3);
        this.getField('cancelar_ventas').setClick(this.LimpiarTab3); 

        //TAB4
        this.getField('continuar_cartera').setClick(this.validarContinuarTab4);
        this.getField('cancelar_cartera').setClick(this.LimpiarTab4);

        //TAB5
        this.getField('continuar_mas_datos').setClick(this.validarContinuarTab5);
        this.getField('cancelar_mas_datos').setClick(this.LimpiarTab5);

        //EMPEZAR DE NUEVO
        this.getField('TabJaivana_329').setClick(this.limpiartodo);



    }

    //TAB1
    deshabilitarCampos(){
        this.getField("nombre").setDisabled(true);
        this.getField("sede").setDisabled(true);
        this.getField("email").setDisabled(true);
        this.getField('alias').setValue(".");

    }

    validarContinuarTab1(){
        
        if(this.getField('codigo_interno').valid() && this.getField('nit').valid() && this.getField('estadosactivos_id').valid() &&
        this.getField('nombre_usuario').valid() && this.getField('email').valid() && this.getField('alias').valid()) {

            //this.datosAgregar.datos['codigo_interno']=this.getField('codigo_interno').getValue();
            //this.datosAgregar.datos['nombre_usuario']=this.getField('nombre_usuario').getValue();


            let datos={ datos: {codigo_interno: this.getField('codigo_interno').getValue()}};

            this.generalFormatPmv = { tipo_servicio: 'heus-crearusuario', operacion: 'validarusuario', operacion_tipo: 'consulta' };
            this.service.send(
            {
                    endpoint: this.constant.formConfiguration(),
                    method:'GET',
                    body: datos,
                    success: this.sucessValidarUsuario,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
            });
        }
    
    }

    sucessValidarUsuario(data){
        if (data.estado_p === 200 ){
            this.alertGeneral.toggle(true, 'El código del usuario ya existe', 'error');
        }else{
            this.getField('TabJaivana_329').setNextTab();
            this.initFormT2();
        }
    }

    LimpiarTab1(){
        this.getField('codigo_interno').setValue("");
        this.getField('nit').setValue("");
        this.getField('sede').setValue("");
        this.getField('nombre').setValue("");
        this.getField('estadosactivos_id').setValue("");
        this.getField('nombre_usuario').setValue("");
        this.getField('email').setValue("");
        this.getField('alias').setValue("");

    }



    //TAB2
    initFormT2(){
        this.getField("codigo_interno_sucursales").setDisabled(true);
        this.getField("nombre_usuario_sucursales").setDisabled(true);
        this.getField("codigo_interno_sucursales").setValue(this.getField("codigo_interno").getValue());
        this.getField("nombre_usuario_sucursales").setValue(this.getField("nombre_usuario").getValue());
    }


    traerSucursalesActivas(){
        if (this.getField("nombre_sucursal").getValue()!==''){
          
            let datos={datos:{}};

            this.generalFormatPmv = { tipo_servicio: '43', operacion: '1', operacion_tipo: 'consulta' };
            this.service.send(
            {
                    endpoint: this.constant.formConfiguration(),
                    method:'GET',
                    body: datos,
                    success: this.sucessTraerSucursales,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
            });  
        }else{
            this.getField('rejilla').toggle(true);
            this.gridOptionsSucursales['rowData'] = [];
        }
    }

    sucessTraerSucursales(data){
        this.getField('nombre_sucursal').setError(false, "");
        if (!this.sucursalesSeleccionadas) {
            this.sucursalesSeleccionadas = new Set();
        }
        if (data.estado_p === 200 ){
            this.getField('rejilla').toggle(true);
            
            this.configCell.set('accion', { cellRenderer: this.setButtonsTable, width: 150, sortable: false, filter: false, field: 'acciones' });
            this.gridOptionsSucursales['rowData'] = data.data;
            this.getField('rejilla').initData(this.gridOptionsSucursales, this.configCell);
        }else{
            this.alertGeneral.toggle(true, 'No hay datos de sucursales.', 'error');
        }
    }

    setButtonsTable(props){
        try {
            let fragment = document.createDocumentFragment();
            let buttonA = this.crearBotonTabla(props.data, 'Agregar');
            let buttonI = this.crearBotonTabla(props.data, 'Eliminar');

            buttonA.setAttribute("class","buttonStyle2");
            buttonI.setAttribute("class","buttonStyle2");

            // Deshabilitar el botón Agregar si ya está seleccionado
            if (this.sucursalesSeleccionadas && this.sucursalesSeleccionadas.has(props.data.sucursales_codigo)) {
                buttonA.disabled = true;
            }

            fragment.appendChild(buttonA);
            fragment.appendChild(buttonI);
            return this.createElementJaivana(fragment)
        } catch (error) {
            this.alertGeneral.toggle(true, 'Error cargando las acciones.', 'error');
        }
    }

    crearBotonTabla(data, boton) {
        let button = document.createElement('input');
        switch (boton) {
            case 'Agregar':
                button.setAttribute("id", `buttonAgregar_${data.id}`);
                break;

            case 'Eliminar':
                button.setAttribute("id", `buttonEliminar_${data.id}`);
                break;

            default:
                break;
        }
        button.onclick = () => { this.accionProcesar(data, boton) };
        button.setAttribute("value", boton);
        button.setAttribute("type", "button");
        return button;

    }

    accionProcesar(data, boton) {
        if (boton === 'Eliminar') {
            this.getField('confirmModalCustom').setTitleAndContent('Eliminar', '¿Desea realizar esta operación?');
            this.getField('confirmModalCustom').setClickDialog(() => { 
                
                // Eliminar del Set y actualizar campo
                this.sucursalesSeleccionadas.delete(data.sucursales_codigo);
                this.actualizarCampoSucursales();
                this.getField('confirmModalCustom').toggle(false);
            });
            this.getField("confirmModalCustom").setVisibleCancel(false);
            this.getField("confirmModalCustom").setButtonConfirm(`Confirmar`);
            this.getField('confirmModalCustom').toggle(true);

        } else if (boton === 'Agregar') {
            
            // Agregar al Set y actualizar campo
            this.sucursalesSeleccionadas.add(data.sucursales_codigo);
            this.actualizarCampoSucursales();

        } else {
            this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `Ninguna acción pertenece a la acción de este botón`);
            this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
            this.getField("confirmModalCustom").setVisibleCancel(true);
            this.getField("confirmModalCustom").setButtonConfirm(`Ok`);
            this.getField('confirmModalCustom').toggle(true);
        }
    }

    actualizarCampoSucursales() {
        const valorConcatenado = Array.from(this.sucursalesSeleccionadas).join(',');
        this.getField("sucursales_permitidas").setValue(valorConcatenado);
    }

    validarContinuarTab2(){
        if(this.getField('nombre_sucursal').valid() && this.getField('sucursales_permitidas').valid()) {
            this.getField('TabJaivana_329').setNextTab();   
            this.initFormT3();         
        }
    }

    LimpiarTab2(){
        this.gridOptionsSucursales['rowData'] = [];
        this.getField('rejilla').toggle(false); 
                
        this.getField('sucursales_permitidas').setValue("");
        this.getField('nombre_sucursal').setValue("");
        this.getField('sucursal_principal').setValue("");
        this.sucursalesSeleccionadas = new Set();
    }
    


    //TAB3
    initFormT3(){
        this.getField("codigo_interno_ventas").setDisabled(true);
        this.getField("nombre_usuario_ventas").setDisabled(true);
        this.getField("codigo_interno_ventas").setValue(this.getField("codigo_interno").getValue());
        this.getField("nombre_usuario_ventas").setValue(this.getField("nombre_usuario").getValue());
    }

    traerVendedores(){
        const estado = Number(this.getField("estadosino_vendedor").getValue());

        if (estado === 1) {
            this.getField("codigo_vendedor").setDisabled(false);
            this.getField("nombre_vendedor").setDisabled(false);
            this.getField("codigo_vendedor").setValue("");
            this.getField("nombre_vendedor").setValue("");
            this.getField("vendedor_id").setValue("");            
            this.getField("codigo_facturacion").setDisabled(false);
            this.getField("detalle_facturacion").setDisabled(false);
            this.getField("codigo_facturacion").setValue("");
            this.getField("detalle_facturacion").setValue("");
            this.getField("bodega_principal").setDisabled(false);
            this.getField("nombre_bodega_principal").setDisabled(false);
            this.getField("bodega_principal").setValue("");
            this.getField("nombre_bodega_principal").setValue("");
        } else if (estado === 2) {
            this.getField("codigo_vendedor").setDisabled(true);
            this.getField("nombre_vendedor").setDisabled(true);
            this.getField("codigo_vendedor").setValue(".");
            this.getField("nombre_vendedor").setValue(".");
            this.getField("vendedor_id").setValue("");        
            this.getField("codigo_facturacion").setDisabled(true);
            this.getField("detalle_facturacion").setDisabled(true);
            this.getField("codigo_facturacion").setValue("99");
            this.getField("detalle_facturacion").setValue(".");
            this.getField("bodega_principal").setDisabled(true);
            this.getField("nombre_bodega_principal").setDisabled(true);
            this.getField("bodega_principal").setValue(".");
            this.getField("nombre_bodega_principal").setValue(".");   
        } else {
            this.getField("codigo_vendedor").setDisabled(true);
            this.getField("nombre_vendedor").setDisabled(true);
            this.getField("codigo_vendedor").setValue("");
            this.getField("nombre_vendedor").setValue("");
            this.getField("vendedor_id").setValue("");
            this.getField("codigo_facturacion").setDisabled(true);
            this.getField("detalle_facturacion").setDisabled(true);
            this.getField("codigo_facturacion").setValue("");
            this.getField("detalle_facturacion").setValue("");
            this.getField("bodega_principal").setDisabled(true);
            this.getField("nombre_bodega_principal").setDisabled(true);
            this.getField("bodega_principal").setValue("");
            this.getField("nombre_bodega_principal").setValue("");   
        }
    }

    validarContinuarTab3(){
        if(this.getField('estadosino_vendedor').valid() && this.getField('nombre_vendedor').valid() && this.getField('detalle_facturacion').valid()
        && this.getField('nombre_bodega_principal').valid() && this.getField('estadosino_supervisor').valid() && this.getField('estadosino_autorizado_costos').valid()) {
            this.getField('TabJaivana_329').setNextTab();   
            this.initFormT4();         
        }
    }

    LimpiarTab3(){                
        this.getField('estadosino_vendedor').setValue("");
        this.getField('estadosino_supervisor').setValue("");
        this.getField('estadosino_autorizado_costos').setValue("");
        this.getField("codigo_vendedor").setDisabled(true);
        this.getField("nombre_vendedor").setDisabled(true);
        this.getField("codigo_vendedor").setValue("");
        this.getField("nombre_vendedor").setValue("");
        this.getField("vendedor_id").setValue("");
        this.getField("codigo_facturacion").setDisabled(true);
        this.getField("detalle_facturacion").setDisabled(true);
        this.getField("codigo_facturacion").setValue("");
        this.getField("detalle_facturacion").setValue("");
        this.getField("bodega_principal").setDisabled(true);
        this.getField("nombre_bodega_principal").setDisabled(true);
        this.getField("bodega_principal").setValue("");
        this.getField("nombre_bodega_principal").setValue("");    
    }





    //TAB4
    initFormT4(){
        this.getField("codigo_interno_cartera").setDisabled(true);
        this.getField("nombre_usuario_cartera").setDisabled(true);
        this.getField("codigo_interno_cartera").setValue(this.getField("codigo_interno").getValue());
        this.getField("nombre_usuario_cartera").setValue(this.getField("nombre_usuario").getValue());
    }

    validarContinuarTab4(){
        if (this.getField("nivel_autorizacion").valid() && this.getField("estadosino_tipo_bloqueo_cupo").valid() && this.getField("valor_bloqueo_cupo").valid()
        && this.getField("numero_veces_dias").valid() && this.getField("numero_veces_bloqueo_cupo").valid() && this.getField("estadosino_cheque_devuelto").valid()){
            this.getField('TabJaivana_329').setNextTab();
            this.initFormT5();        
        }
    }

    LimpiarTab4(){
        this.getField("nivel_autorizacion").setValue("00");
        this.getField("estadosino_tipo_bloqueo_cupo").setValue("");
        this.getField("valor_bloqueo_cupo").setValue("0");
        this.getField("numero_veces_dias").setValue("0");
        this.getField("numero_veces_bloqueo_cupo").setValue("0");
        this.getField("estadosino_cheque_devuelto").setValue("");
    }


    //TAB5
    initFormT5(){
        this.getField("codigo_interno_mas_datos").setDisabled(true);
        this.getField("nombre_usuario_mas_datos").setDisabled(true);
        this.getField("codigo_interno_mas_datos").setValue(this.getField("codigo_interno").getValue());
        this.getField("nombre_usuario_mas_datos").setValue(this.getField("nombre_usuario").getValue());
    }

    validarContinuarTab5(){
        if (this.getField("nombre_dptointerno").valid()){
            let datos={ datos: {codigo_interno: this.getField('codigo_interno').getValue()}};

            this.generalFormatPmv = { tipo_servicio: 'heus-crearusuario', operacion: 'validarusuario', operacion_tipo: 'consulta' };
            this.service.send(
            {
                    endpoint: this.constant.formConfiguration(),
                    method:'GET',
                    body: datos,
                    success: this.sucessValidarCrearUsuario,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
            });
        }
    }

    sucessValidarCrearUsuario(data){

        if (data.estado_p === 200 ){
            this.alertGeneral.toggle(true, 'El código del usuario ya existe', 'error');
        }else{
            let datos={ 
                datos: {
                    codigo_interno: this.getField('codigo_interno').getValue(),
                    nombre: this.getField('nombre').getValue(),
                    nit: this.getField('nit').getValue(),
                    terceros_id: Number(this.getField('terceros_id').getValue()),
                    estado:this.getField('descripcion_estado_activo').getValue(),
                    estadoactivo_id:Number(this.getField('estadosactivos_id').getValue()),
                    alias:this.getField('alias').getValue(),
                    vendedor:this.getField('descripcion_estado_sino_vendedor').getValue(),
                    supervisor:this.getField('descripcion_estado_sino_supervisor').getValue(),
                    cvendedor:this.getField('codigo_vendedor').getValue(),
                    ver_margen:this.getField('descripcion_estado_sino_vermargen').getValue(),
                    codigo_facturacion:this.getField('codigo_facturacion').getValue(),
                    codigo_sucursal:this.getField('sucursal_principal').getValue(),
                    tipo_bloqueo_cupo:this.getField('descripcion_estado_sino_bloqueocupo').getValue(),
                    tipobloqueocupo_estadosino_id:Number(this.getField('estadosino_tipo_bloqueo_cupo').getValue()),
                    valor_bloqueo_cupo:this.getField('valor_bloqueo_cupo').getValue(),
                    veces_dias:this.getField('numero_veces_dias').getValue(),
                    valor_dias:this.getField('valor_dias').getValue(),
                    veces_bloqueo_cupo:this.getField('numero_veces_bloqueo_cupo').getValue(),
                    cheque_devuelto:this.getField('descripcion_estado_sino_chequedevuelto').getValue(),
                    chequedevuelto_estadosino_id:Number(this.getField('estadosino_cheque_devuelto').getValue()),
                    nivel_autorizacion:this.getField('nivel_autorizacion').getValue(),
                    bodega:this.getField('bodega_principal').getValue(),
                    codigo_vendedor:this.getField('codigo_vendedor').getValue(),
                    sucursal_configuracion:this.getField('sucursal_principal').getValue()+","+this.getField('sucursales_permitidas').getValue(),
                    supervisoresatdosino_id:Number(this.getField('estadosino_supervisor').getValue()),
                    vendedoresatdosino_id:Number(this.getField('estadosino_vendedor').getValue()),
                    ver_margenestadosino_id:Number(this.getField('estadosino_autorizado_costos').getValue()),
                    cedula:this.getField('nit').getValue(),
                    codigodepartamento_id:Number(this.getField('departamento_interno_id').getValue()),
                }
            };

            this.generalFormatPmv = { tipo_servicio: 'heus-crearusuario', operacion: 'crearusuario', operacion_tipo: 'crear' };
            this.service.send(
            {
                    endpoint: this.constant.formConfiguration(),
                    method:'POST',
                    body: datos,
                    success: this.sucessCrearUsuario,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
            });
        }

    }

    sucessCrearUsuario(data){
        if (data.estado_p === 200 ){
            this.alertGeneral.toggle(true, 'Usuario creado con éxito', 'success');
            this.limpiartodo();
        }else{
            this.alertGeneral.toggle(true, 'No se pudo crear el usuario', 'error');
            this.limpiartodo();
        }
    }

    LimpiarTab5(){
        this.getField("codigo_dptointerno").setValue("");
        this.getField("nombre_dptointerno").setValue("");

    }

    limpiartodo(){
        this.getField('TabJaivana_329').reInit();
        this.getField('codigo_interno').setValue("");
        this.getField('nit').setValue("");
        this.getField('sede').setValue("");
        this.getField('nombre').setValue("");
        this.getField('estadosactivos_id').setValue("");
        this.getField('nombre_usuario').setValue("");
        this.getField('email').setValue("");
        this.getField('alias').setValue("");
        this.gridOptionsSucursales['rowData'] = [];
        this.getField('rejilla').toggle(false);                 
        this.getField('sucursales_permitidas').setValue("");
        this.getField('nombre_sucursal').setValue("");
        this.getField('sucursal_principal').setValue("");
        this.getField('estadosino_vendedor').setValue("");
        this.getField('estadosino_supervisor').setValue("");
        this.getField('estadosino_autorizado_costos').setValue("");
        this.getField("codigo_vendedor").setDisabled(true);
        this.getField("nombre_vendedor").setDisabled(true);
        this.getField("codigo_vendedor").setValue("");
        this.getField("nombre_vendedor").setValue("");
        this.getField("vendedor_id").setValue("");
        this.getField("codigo_facturacion").setDisabled(true);
        this.getField("detalle_facturacion").setDisabled(true);
        this.getField("codigo_facturacion").setValue("");
        this.getField("detalle_facturacion").setValue("");
        this.getField("bodega_principal").setDisabled(true);
        this.getField("nombre_bodega_principal").setDisabled(true);
        this.getField("bodega_principal").setValue("");
        this.getField("nombre_bodega_principal").setValue("");  
        this.getField("nivel_autorizacion").setValue("00");
        this.getField("estadosino_tipo_bloqueo_cupo").setValue("");
        this.getField("valor_bloqueo_cupo").setValue("0");
        this.getField("numero_veces_dias").setValue("0");
        this.getField("numero_veces_bloqueo_cupo").setValue("0");
        this.getField("estadosino_cheque_devuelto").setValue("");  
        this.getField("codigo_dptointerno").setValue("");
        this.getField("nombre_dptointerno").setValue("");
        this.getField('alias').setValue(".");
        this.getField("valor_dias").setValue("0");
        this.sucursalesSeleccionadas = new Set();

    }

}
FormJaivana.addController('heus-crearusuario', CustomCrearUsuario);
export default CustomCrearUsuario;